let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("dzT3W")]).then(() => parcelRequire('17J6g'));